import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
}));

export default function RefreshConfirmModal({
  onRefreshConfirm,
  onRefreshCancel,
}) {
  const classes = useStyles();
  const confirmModal = useSelector((state) => state.confirmModal);
  const dispatch = useDispatch();

  const [showDialog, setShowDialog] = useState(true);

  const handleConfirm = () => {
    onRefreshConfirm("yes");
    setShowDialog(false);
  };

  const handleClose = () => {
    onRefreshCancel("no");
    setShowDialog(false);
  };

  return (
    <Dialog
      open={showDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Do you want to reload?</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" style={{color:"rgb(0 0 0 / 93%)"}} >
          Please confirm if you want to reload the chatbox.<br></br>
          Please note that this may result in the loss of your current session’s
          chat data.
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleConfirm} color="primary">
          YES
        </Button>
        <Button onClick={handleClose} color="secondary">
          NO
        </Button>
      </DialogActions>
    </Dialog>
  );
}
